import { 
  createColumnHelper, 
  getCoreRowModel, 
  getFacetedMinMaxValues, 
  getFacetedRowModel, 
  getFacetedUniqueValues, 
  getFilteredRowModel, 
  getPaginationRowModel, 
  getSortedRowModel, 
  SortingState, 
  useReactTable,
} from '@tanstack/react-table'
import React, { useState } from 'react'
import MembersFilterContent from './MembersFilterContent'
import { countUserByRole } from '../Utils'
import CollapsableButton from '../../../../../common/button/CollapsableButton'

const MembersFilter = ({
  from,
  tableData, 
  setColumnFilters
}) => {

  const filterData = [
    {
      name: 'Role',
      items: [
        {
          name: 'owner',
          value: 'Owner',
          checked: false,
          count: countUserByRole( tableData, 'owner')
          
        },
        {
          name: 'manager',
          value: 'Manager',
          checked: false,
          count: countUserByRole( tableData, 'manager')
        },
        {
          name: 'member',
          value: 'Member',
          checked: false,
          count: countUserByRole( tableData, 'member')
        },
      ]
    },
    {
      name: 'Presets',
      items: []
    },
    {
      name: 'Reporting Groups',
      items: []
    },
  ]

  type FilterItems = {
    name: string,
    value?: string,
    checked?: boolean,
    count?: number
  }

  type Filter = {
    name: string,
    items: FilterItems[]
  }

  const [ sorting, setSorting ] = React.useState<SortingState>([])
  const [ rowSelection, setRowSelection ] = React.useState({})
  const defaultData: Filter[] = filterData
  const columnHelper = createColumnHelper<Filter>()
  const [ data, setData ] = React.useState( () => [...defaultData])
  const [ globalFilter, setGlobalFilter ] = React.useState('')
  const [ closed, setClosed ] = useState(false)

  const columns = [
    columnHelper.accessor('name', {
      cell: info => info.getValue()
    }),
    columnHelper.group({
      header: 'Filter Items',
      columns: [
        columnHelper.accessor(row => row.items.map(item => item.name).join(', '), {
          header: 'Item Name',
          cell: info => info.getValue(),
        }),
        columnHelper.accessor(row => row.items.map(item => item.value).join(', '), {
          header: 'Item Value',
          cell: info => info.getValue(),
        }),
      ]
    })
  ]

  const table  = useReactTable({
    data,
    columns,
    state: {
      sorting,
      globalFilter
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: false,
  })

  return (
    <CollapsableButton
      collapsed={false}
      icon={'filter'}
      title={'Filters'}
      heightWidth={12}
      setClosed={ closed }
      disabled={ tableData.length === 0 }
      showPanelHeader={true}
    >
        <MembersFilterContent
          filterData={ filterData }
          data={ data } 
          table={ table }
          columns={ columns }
          rowSelection={ rowSelection }
          setRowSelection={ setRowSelection }
          sorting={ sorting }
          setSorting={ setSorting }
          globalFilter={ globalFilter }
          setGlobalFilter={ setGlobalFilter }
          setData={ setData }
          setColumnFilters={ setColumnFilters }
          from={ from }
          setFilterClosed={ setClosed }
        />
    </CollapsableButton>
  )
}

export default MembersFilter
